import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { changePasswordAction } from '../../_actions';
import '../Login/login.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../images/OPPTIMISE_logo.png';



class ChangeAdminPassword extends React.Component {
    constructor(props) {
        super(props);



        this.state = {

            currentPassword: '',
            confirmNewPassword: '',
            newPassword: '',
            submitted: false,
            passwordCheck: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const data = {
            old_password: this.state.currentPassword,
        
            new_password: this.state.newPassword
        }
        if (this.state.newPassword !== this.state.confirmNewPassword) {
            this.setState({ passwordCheck: true })


        } else {
            this.setState({ passwordCheck: false })

            this.props.dispatch(changePasswordAction.changePasswordHandler(data));
        }


    }



    render() {

        const { currentPassword, newPassword, confirmNewPassword, submitted, passwordCheck } = this.state;
        const { changePasswordLoading, changePasswordResponseCode } = this.props;

        return (
            <div className="login-page text-white">
                <div className="logo text-center text-md-left py-3 px-md-5">
                    <img src={logo} alt="OPPTiMiSE" />


                </div>

                <div className="container pt-5">
                    <div className="d-flex flex-row justify-content-center">
                        <div className="col-lg-5 col-md-8 col-11 px-0">
                            <div className="login-field-page">
                                <p className="h4 text-center py-3 py-lg-2">Change Password</p>

                                {
                                    passwordCheck &&
                                    <p className="text-center">"Confirm Password" does not match Password</p>
                                }
                                <div className="">
                                    <form
                                        method="post"
                                        onSubmit={
                                            this.handleSubmit
                                        }
                                    >
                                        <div className="form-group">
                                            <label htmlFor="currentPassword" className="text-uppercase"><small>current password</small></label>
                                            <input
                                                type="password" className="form-control" id="currentPassword" placeholder="current password"
                                                name="currentPassword"
                                                required
                                                value={currentPassword}
                                                onChange={this.handleChange}
                                            />
                                            {submitted && !currentPassword &&
                                                <div className="help-block">current Password is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="newPassword" className="text-uppercase"><small>new password</small></label>
                                            <input
                                                type="password" className="form-control" id="newPassword" placeholder="new password"
                                                name="newPassword"
                                                required
                                                value={newPassword}
                                                onChange={this.handleChange}
                                            />
                                            {submitted && !newPassword &&
                                                <div className="help-block">NewPassword is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="confirmNewPassword" className="text-uppercase"><small>Confirm New Password</small></label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="confirmNewPassword"
                                                placeholder="confirm new password"
                                                name="confirmNewPassword"
                                                required
                                                value={confirmNewPassword}
                                                onChange={this.handleChange}
                                            />
                                            {submitted && !confirmNewPassword &&
                                                <div className="help-block">Confirm New Password is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <div className="text-center">
                                                <button
                                                    type="submit"
                                                    className="btn buttonColor btn-sm text-white px-3"
                                                >
                                                    <small>CHANGE PASSWORD</small>
                                                </button>
                                            </div>
                                        </div>
                                        <p className="text-center "><Link className="text-white" to='/app/dashBoard'> <small>Back to Dashboard</small></Link></p>


                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>




        );
    }
}

function mapStateToProps(state) {

    const { changePasswordLoading } = state.changePasswordReducer;
    const changePasswordResponseCode = (!changePasswordLoading) ? state.changePasswordReducer.data.status : '';
    return {
        changePasswordLoading,
        changePasswordResponseCode

    };
}

const connectedChangePassword = connect(mapStateToProps)(ChangeAdminPassword);
export { connectedChangePassword as ChangeAdminPassword }; 


// WEBPACK FOOTER //
// ./src/_pages/ChangeAdminPassword/index.jsx